import {
  ArrowRight,
  MapPin,
  Users,
  Star,
  Globe,
  ArrowDown,
  CheckCircle,
  XCircle,
  Briefcase,
  DollarSign,
  MessageSquare,
  Shield,
  BarChart,
  Map,
  Compass,
  Heart,
  UserPlus,
} from "lucide-react";
import { isMobile } from "react-device-detect";

const SotravelXInfo = () => {
  return (
    <div className="tw-min-h-screen tw-font-sans">
      {/* Hero Section with Parallax Effect */}
      <section className="tw-relative tw-h-[70vh] tw-overflow-hidden">
        <div
          className="tw-absolute tw-inset-0 tw-scale-110 tw-transform tw-bg-cover tw-bg-center"
          style={{
            backgroundImage:
              "url('https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/151028Copy%20of%20IMG_4012.JPG')",
            transform: "translateZ(-1px) scale(1)",
          }}
        />
        <div className="tw-absolute tw-inset-0 tw-bg-black/50" />
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
          <div className="tw-max-w-4xl tw-px-4 tw-text-center tw-text-white">
            <h1 className="tw-mb-3 tw-text-[34px] tw-font-bold tw-leading-tight md:tw-text-[52px]">
              Take your travel passion to the next level
            </h1>
            <p className="tw-mx-auto tw-mb-5 tw-max-w-2xl tw-text-[18px] tw-text-gray-200 md:tw-text-[20px]">
              Create and sell unique group trips with Sotravel X
            </p>
            <button
              onClick={() => window.open("https://t.me/m/WhitDFiSOGY1", "_blank")}
              className="tw-rounded-full tw-bg-[#00BFFF] tw-px-6 tw-py-2.5 tw-text-[16px] tw-font-medium tw-text-white tw-transition tw-duration-300 hover:tw-bg-[#00A3D9]"
            >
              Chat with us
            </button>
          </div>
        </div>
      </section>

      {/* Why Host a Trip Section */}
      <section className="tw-bg-white tw-py-12">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-8 tw-text-center tw-text-[26px] tw-font-bold">
            Why Host a Trip with Sotravel X?
          </h2>
          <p className="tw-mx-auto tw-mb-8 tw-max-w-3xl tw-text-center tw-text-[18px] tw-text-gray-600">
            Sotravel X empowers individuals to design and sell their own group travel
            experiences—without the hassle of logistics, customer service, or payment processing.
          </p>
          <div className="tw-mx-auto tw-grid tw-max-w-5xl tw-gap-6 md:tw-grid-cols-3">
            <div className="tw-rounded-lg tw-bg-white tw-p-6 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]">
                  <DollarSign className="tw-h-6 tw-w-6 tw-text-white" />
                </div>
                <div>
                  <h3 className="tw-mb-2 tw-text-[20px] tw-font-medium">
                    Earn from your expertise
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    Create trips tailored to your niche and monetize your travel knowledge and
                    audience.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-rounded-lg tw-bg-white tw-p-6 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]">
                  <Users className="tw-h-6 tw-w-6 tw-text-white" />
                </div>
                <div>
                  <h3 className="tw-mb-2 tw-text-[20px] tw-font-medium">Sell out faster</h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    Access built-in marketing tools and an engaged traveler community to fill your
                    trips quickly.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-rounded-lg tw-bg-white tw-p-6 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]">
                  <Compass className="tw-h-6 tw-w-6 tw-text-white" />
                </div>
                <div>
                  <h3 className="tw-mb-2 tw-text-[20px] tw-font-medium">Focus on experiences</h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    We handle customer management, payments, and coordination so you can focus on
                    creating amazing trips.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who Can Become a Trip Creator Section */}
      <section className="tw-bg-gray-50 tw-py-12">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-8 tw-text-center tw-text-[26px] tw-font-bold">
            Who can become a trip creator?
          </h2>
          <p className="tw-mx-auto tw-mb-8 tw-max-w-3xl tw-text-center tw-text-[18px] tw-text-gray-600">
            Sotravel X is built for passionate individuals who want to share their travel expertise
          </p>
          <div className="tw-mx-auto tw-grid tw-max-w-5xl tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-4">
            <div className="tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-mb-3 tw-flex tw-items-center tw-gap-3">
                <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]/10">
                  <Star className="tw-h-5 tw-w-5 tw-text-[#00BFFF]" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">Content creators & influencers</h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who want to travel with their audience and create deeper connections
              </p>
            </div>
            <div className="tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-mb-3 tw-flex tw-items-center tw-gap-3">
                <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]/10">
                  <Map className="tw-h-5 tw-w-5 tw-text-[#00BFFF]" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">Travel enthusiasts & experts</h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Looking to share their favorite destinations and insider knowledge
              </p>
            </div>
            <div className="tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-mb-3 tw-flex tw-items-center tw-gap-3">
                <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]/10">
                  <Users className="tw-h-5 tw-w-5 tw-text-[#00BFFF]" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">Community leaders</h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who already bring people together and want to expand to travel experiences
              </p>
            </div>
            <div className="tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-sm tw-transition-shadow tw-duration-300 hover:tw-shadow-md">
              <div className="tw-mb-3 tw-flex tw-items-center tw-gap-3">
                <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#00BFFF]/10">
                  <Briefcase className="tw-h-5 tw-w-5 tw-text-[#00BFFF]" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">Aspiring travel entrepreneurs</h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who want to run trips without the upfront costs and operational headaches
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="tw-bg-white tw-py-12">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-8 tw-text-center tw-text-[26px] tw-font-bold">How It Works</h2>
          <div className="tw-relative tw-mx-auto tw-max-w-4xl">
            <div className="tw-absolute tw-left-[3%] tw-z-10 tw-h-full tw-w-1 -tw-translate-x-1/2 tw-transform tw-bg-[#00BFFF] md:tw-left-[25%]">
              <div className="tw-absolute -tw-top-2 tw-left-1/2 tw-h-4 tw-w-4 -tw-translate-x-1/2 tw-rounded-full tw-bg-[#00BFFF]"></div>
              <div className="tw-absolute -tw-bottom-2 tw-left-1/2 tw-h-4 tw-w-4 -tw-translate-x-1/2 tw-rounded-full tw-bg-[#00BFFF]"></div>
            </div>
            <div className="tw-space-y-6 md:tw-space-y-8">
              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                {!isMobile && (
                  <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                    <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                  </div>
                )}
                <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                  <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                    <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                      1. Apply & submit your trip concept
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Share your trip idea, target audience, and what makes your experience unique.
                      Our team will review your application and get back to you quickly.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                  <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                  <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                    <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                      2. Work with our team on trip details
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Collaborate with our travel experts to finalize itinerary, pricing,
                      inclusions, and marketing strategy to ensure your trip stands out.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                  <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                  <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                    <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                      3. List your trip & start collecting bookings
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Your trip goes live on our platform. Promote it to your audience while we also
                      market it to our community of travelers.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                  <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                  <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                    <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                      4. We handle the logistics
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Sotravel X takes care of customer sign-ups, payments, and coordination with
                      suppliers so you don't have to worry about the details.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                  <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                  <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                    <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                      5. Lead an unforgettable experience
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Focus on creating amazing memories with your travelers—or build a team to run
                      the trip for you while you scale to multiple destinations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-bg-gray-50 tw-py-16">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-12 tw-text-center tw-text-3xl tw-font-bold md:tw-text-4xl">
            Why choose Sotravel X over doing it alone?
          </h2>

          <div className="tw-mx-auto tw-max-w-5xl tw-overflow-hidden tw-rounded-xl tw-bg-white tw-shadow-md">
            <div className="tw-grid md:tw-grid-cols-2">
              {/* Header */}
              <div className="tw-border-b tw-border-gray-200 tw-bg-gray-100 tw-p-4 tw-text-center tw-font-semibold">
                Without Sotravel X
              </div>
              <div className="tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/10 tw-p-4 tw-text-center tw-font-semibold">
                With Sotravel X
              </div>

              {/* Row 1 */}
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>Handling customer inquiries</span>
              </div>
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>We manage customer communication</span>
              </div>

              {/* Row 2 */}
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>Dealing with payment collection & refunds</span>
              </div>
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>We process payments & handle refunds</span>
              </div>

              {/* Row 3 */}
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>Coordinating logistics with local guides</span>
              </div>
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>We help to coordinate with the local guides</span>
              </div>

              {/* Row 4 */}
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>Struggling to sell out your trip</span>
              </div>
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>Get access to a traveler audience & marketing tools</span>
              </div>

              {/* Row 5 */}
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>Managing bookings manually</span>
              </div>
              <div className="tw-flex tw-items-center tw-border-b tw-border-gray-200 tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>Centralized booking & trip management dashboard</span>
              </div>

              {/* Row 6 */}
              <div className="tw-flex tw-items-center tw-p-4">
                <XCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-red-500" size={20} />
                <span>No support in case of issues</span>
              </div>
              <div className="tw-flex tw-items-center tw-bg-[#00BFFF]/5 tw-p-4">
                <CheckCircle className="tw-mr-3 tw-flex-shrink-0 tw-text-green-500" size={20} />
                <span>Dedicated team for assistance</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-bg-[#00BFFF]/5 tw-py-16">
        <div className="tw-container tw-mx-auto tw-px-4 tw-text-center">
          <h2 className="tw-mb-6 tw-text-3xl tw-font-bold md:tw-text-4xl">
            Ready to launch your first trip?
          </h2>
          <p className="tw-mx-auto tw-mb-10 tw-max-w-2xl tw-text-xl tw-text-gray-600">
            Apply now and start building your first trip with Sotravel X.
          </p>
          <button
            onClick={() => window.open("https://t.me/m/WhitDFiSOGY1", "_blank")}
            className="tw-rounded-full tw-bg-[#00BFFF] tw-px-8 tw-py-3 tw-text-lg tw-font-medium tw-text-white tw-shadow-md tw-transition-all tw-duration-300 hover:tw-bg-[#00BFFF]/90 hover:tw-shadow-lg"
          >
            Apply here
          </button>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="tw-bg-white tw-py-16">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-12 tw-text-center tw-text-3xl tw-font-bold md:tw-text-4xl">
            Frequently asked questions
          </h2>

          <div className="tw-mx-auto tw-max-w-4xl tw-space-y-6">
            <div className="tw-rounded-lg tw-bg-gray-50 tw-p-6 tw-shadow-sm">
              <h3 className="tw-mb-3 tw-text-xl tw-font-semibold">
                Who can become a Sotravel X trip creator?
              </h3>
              <p className="tw-text-gray-600">
                This program is ideal for content creators, local experts, community leaders, or
                travel enthusiasts with a specific niche or audience!
              </p>
            </div>

            <div className="tw-rounded-lg tw-bg-gray-50 tw-p-6 tw-shadow-sm">
              <h3 className="tw-mb-3 tw-text-xl tw-font-semibold">
                Do I need to have travel industry experience?
              </h3>
              <p className="tw-text-gray-600">
                No prior industry experience is required. Our platform is designed to handle the
                technical aspects while you focus on creating amazing experiences. We provide
                training and support throughout the process.
              </p>
            </div>

            <div className="tw-rounded-lg tw-bg-gray-50 tw-p-6 tw-shadow-sm">
              <h3 className="tw-mb-3 tw-text-xl tw-font-semibold">
                How much does it cost to use Sotravel X?
              </h3>
              <p className="tw-text-gray-600">
                There's no upfront cost to join. We operate on a revenue-share model, taking a
                percentage of bookings. This means we only make money when you do, aligning our
                interests with your success.
              </p>
            </div>

            <div className="tw-rounded-lg tw-bg-gray-50 tw-p-6 tw-shadow-sm">
              <h3 className="tw-mb-3 tw-text-xl tw-font-semibold">
                How does the application process work?
              </h3>
              <p className="tw-text-gray-600">
                It typically takes around 2 weeks for us to go from idea to a live trip! To start,
                simply chat with us on Telegram where we can get to know each other and share more
                about the process!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="tw-bg-gradient-to-r tw-from-[#00BFFF] tw-to-[#0077B6] tw-py-20 tw-text-white">
        <div className="tw-container tw-mx-auto tw-px-4 tw-text-center">
          <h2 className="tw-mb-6 tw-text-3xl tw-font-bold md:tw-text-4xl">
            Take your travel passion to the next level
          </h2>
          <p className="tw-mx-auto tw-mb-10 tw-max-w-2xl tw-text-xl tw-opacity-90">
            Join Sotravel X today and start creating unforgettable travel experiences.
          </p>
          <button
            onClick={() => window.open("https://t.me/m/WhitDFiSOGY1", "_blank")}
            className="tw-rounded-full tw-bg-white tw-px-8 tw-py-3 tw-text-lg tw-font-bold tw-text-[#00BFFF] tw-shadow-md tw-transition-all tw-duration-300 hover:tw-bg-gray-100 hover:tw-shadow-lg"
          >
            Chat with us <ArrowRight className="tw-ml-2 tw-inline" size={20} />
          </button>
        </div>
      </section>
    </div>
  );
};

export default SotravelXInfo;
